<template>
  <div class="Home-Container">
    <vv-box :title="$t('userAccount.formationsTitle')" :unpadded="true">
      <vv-box-item
        :title="$t('userAccount.myFormations')"
        @click="$router.push({ name: 'themeList' })"
      >
        <img src="@/assets/visite.png" width="25" height="22" />
      </vv-box-item>

      <vv-box-item :title="$t('home.tasting')" @click="$router.push('/listTasting')">
        <img src="@/assets/degustation.png" width="25" height="22" />
      </vv-box-item>

      <vv-box-item
        :title="$t('userAccount.lovedWines')"
        @click="$router.push({ name: 'userAccountFavoriteWine' })"
      >
        <img src="@/assets/tasted_wines.png" width="25" height="22" />
      </vv-box-item>

      <vv-box-item :title="$t('home.quiz')" @click="$router.push('/quiz')">
        <img src="@/assets/quiz.png" width="25" height="22" />
      </vv-box-item>

      <vv-box-item
        :title="$t('userAccount.personalInformation')"
        @click="$router.push({ name: 'userAccountPersonnalInformation' })"
      >
        <img src="@/assets/people.png" width="25" height="22" />
      </vv-box-item>

      <vv-box-item
        title="Scan QrCode"
        @click="$router.push({ name: 'qrcode' })"
      >
        <img src="@/assets/picto_side_qrcode.png" width="25" height="25" />
      </vv-box-item>

      <vv-box-item :title="$t('home.shop')" @click="redirectToShop">
        <img src="@/assets/boutique.png" width="25" height="22" />
      </vv-box-item>

      <vv-box-item
        v-if="availableLocales.length >= 2"
        :title="$t('userAccount.language')"
        @click="$router.push({ name: 'userAccountLanguage' })"
      >
        <img src="@/assets/langues.png" width="26" height="22" />
      </vv-box-item>

      <vv-box-item
        v-if="isUserLogged"
        @click="logout"
        :title="$t('global.logout')"
        :show-arrow="false"
      >
        <img src="@/assets/logout.png" width="25" height="22" />
      </vv-box-item>
    </vv-box>
    <div class="list-social-media">
      <div class="item-social-media" v-for="media in socialMedia" :key="media.id">
        <a :href="media.link" target="_blank"><img :src="require(`@/assets/media_logo/${media.label}_logo.png`)"></a>
      </div>
    </div>
  </div>
</template>

<script>
import VvBox from '@/components/common/VvBox'
import VvBoxItem from '@/components/common/VvBoxItem'

import userMixin from '@/mixins/user'
import remoteConfigMixin from '@/mixins/remoteConfig'
import remoteConfig from '@/lib/remote-config'

export default {
  name: 'Home',
  mixins: [userMixin, remoteConfigMixin],
  components: {
    VvBox,
    VvBoxItem
  },
  computed: {
    availableLocales() {
      const languages = this.remoteConfig.getString('languages')

      if (languages) {
        return languages.split('|')
      }

      return []
    },
    socialMedia() {
      if (remoteConfig.getValue('social_media')) {
        return JSON.parse(JSON.parse(JSON.stringify(remoteConfig.getValue('social_media'))))
      }
      return []
    }
  },
  methods: {
    startVisit() {
      if (this.themes.length > 0) {
        this.$router.push({ name: 'themeList' })
      }
    },
    redirectToShop() {
      window.open(this.remoteConfig.getString('shop_url'), '_blank')
    }
  }
}
</script>

<style scoped lang="scss">
.Home-Container {
  text-align: left;
}
.list-social-media {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  justify-content: center;
  align-items: center;
  margin-top: 20px;

  .item-social-media {
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    flex-wrap: wrap;
    align-items: center;
    margin-left: 10px;
    margin-right: 10px;
    .asset-rrecommendations {
      flex-direction: row;
    }

    img {
      width: 25px;
      height: 25px;
    }
  }
}
</style>
